import { Field, ID, ObjectType } from 'type-graphql'
import { modelOptions, Prop, PropType, Severity } from '@typegoose/typegoose'
import { Asset, BaseEntity, Contact, generateEntityId } from '@ztechapps/common.contract'
import GraphQLJSON from 'graphql-type-json'
import { HaulerLogo } from './HaulerLogo'
import { SyncInfo } from './SyncInfo'
import { HaulerPlant, PlantBtu, PlantSilo } from '@ztechapps/totalmilk-tmms.common'
import { HaulerCustomerUnitId } from './HaulerCustomerUnitId'

@modelOptions({ schemaOptions: { strict: false }, options: { allowMixed: Severity.ALLOW } })
@ObjectType()
export class HaulerCustomer extends BaseEntity {
  @Field(() => ID)
  @Prop({ type: String, required: true, default: () => generateEntityId('hcust') })
  declare _id: string

  @Field(() => String, { nullable: true })
  @Prop({ type: String })
  title?: string

  @Field(() => String, { nullable: true })
  @Prop({ type: String })
  type?: string

  @Field(() => Contact, { nullable: true })
  @Prop({ type: Contact })
  contact?: ReturnType<() => Contact>

  @Field(() => HaulerLogo, { nullable: true })
  @Prop({ type: HaulerLogo })
  logo?: ReturnType<() => HaulerLogo>

  @Field(() => SyncInfo, { nullable: true })
  @Prop({ type: SyncInfo })
  _syncInfo?: ReturnType<() => SyncInfo>

  @Field(() => HaulerPlant, { nullable: true })
  @Prop({ type: HaulerPlant })
  plant?: ReturnType<() => HaulerPlant>

  @Field(() => String, { nullable: true })
  @Prop({ type: String })
  reportId?: string

  @Field(() => [HaulerCustomerUnitId], { nullable: true })
  @Prop({ type: [HaulerCustomerUnitId] }, PropType.ARRAY)
  unitIds?: ReturnType<() => HaulerCustomerUnitId[]>

  @Field(() => [PlantBtu], { nullable: true })
  @Prop({ type: [PlantBtu] }, PropType.ARRAY)
  btus?: ReturnType<() => PlantBtu[]>

  @Field(() => [PlantSilo], { nullable: true })
  @Prop({ type: [PlantSilo] }, PropType.ARRAY)
  silos?: ReturnType<() => PlantSilo[]>

  @Field(() => [Asset], { nullable: true })
  @Prop({ type: [Asset] }, PropType.ARRAY)
  assets?: ReturnType<() => Asset[]>

  @Field(() => GraphQLJSON, { nullable: true })
  templateData?: Record<string, unknown>
}
